import { render, staticRenderFns } from "./DeadlineRenderer.vue?vue&type=template&id=2929e48c"
import script from "./DeadlineRenderer.vue?vue&type=script&lang=js"
export * from "./DeadlineRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports